export default __webpack_public_path__ + "static/media/arrow-rounded-left-7x11.3569d71d.svg";